/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Button, InputGroup,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import moment from 'moment';
import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';

import { post } from '../../helpers/api_helper';
import BaseGrid from '../Common/BaseGrid';

function AddressingForm(props) {
  const { entity, t } = props;

  const [loading, setLoading] = useState(false);

  const startRef = useRef(null);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      if (loading) return;

      setLoading(true);

      const data = { ...values };
      data.start = parseInt(data.start, 36);
      data.end = parseInt(data.end, 36);

      const result = await post('/api/tvs/addressing', data);

      toastr.success(t(`Address ${result.id} saved`), t('Success'));
      props.onSuccess(result);
    } catch (error) {
      toastr.error(t('Error saving addressing'), t('Error'));
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    start: Yup.string().required(t('Start Label is required')),
    end: Yup.string().required(t('End Label is required')),
    truck: Yup.object().shape({
      id: Yup.number(),
    }).required(t('Truck is required')),
    order_id: Yup.number().required(t('Order is required')),
  });

  useEffect(() => {
    if (startRef.current) {
      startRef.current.focus();
    }
  }, []);

  const jsx = (
    <Formik
      enableReinitialize
      initialValues={entity}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        save(values);
      }}
    >
      {({
        touched, errors, values, setFieldValue,
      }) => (
        <Form id="AddressingForm" autoComplete="off">
          <Row className="border-bottom pb-3 mb-4">
            <Col sm="6">
              <Label
                for="start"
                className="pe-0 ps-0"
              >
                {props.t('Start Label')}
              </Label>
              <Field
                type="text"
                innerRef={startRef}
                className={`form-control ${(errors.start && touched.start ? 'is-invalid' : '')}`}
                id="start"
                name="start"
                placeholder="BBC1"
              />
              <div className="help-block text-muted pt-1">
                {props.t('One end of the reel of sort labels')}
              </div>
              <ErrorMessage
                name="start"
                component="div"
                className="text-danger"
              />
            </Col>

            <Col sm="6">
              <Label
                for="end"
                className="pe-0 ps-0"
              >
                {props.t('End Label')}
              </Label>
              <Field
                type="text"
                className={`form-control ${(errors.end && touched.end ? 'is-invalid' : '')}`}
                id="end"
                name="end"
                placeholder="BBC7"
              />
              <div className="help-block text-muted pt-1">
                {props.t('Other end of the reel of sort labels')}
              </div>
              <ErrorMessage
                name="end"
                component="div"
                className="text-danger"
              />
            </Col>
          </Row>

          {(values.truck === null || values.truck === undefined) && (
            <div>
              <h5>
                {props.t('Select a Truck')}
              </h5>
              <BaseGrid
                url="/api/sourcing/trucks"
                filters="hasOrders=1"
                hasSearch
                config={
                {
                  rowClass: (ent) => {
                    if (ent.received_at === null
                      && moment(ent.expected_at).isBefore(moment())) {
                      return 'table-danger';
                    }

                    if (ent.received_at === null) {
                      return 'table-warning';
                    }

                    return '';
                  },
                  columns: {
                    id: {
                      label: 'ID',
                      sort: true,
                    },
                    reference: {
                      label: 'Reference',
                      sort: true,
                    },
                    outbound: {
                      label: 'In/Out',
                      html: true,
                      format: (field) => {
                        if (field) {
                          return `<span class="badge bg-danger">${t('Outbound')}</span>`;
                        }

                        return `<span class="badge bg-warning text-dark">${t('Inbound')}</span>`;
                      },
                    },
                    created_at: {
                      label: 'Created',
                      date: {
                        format: (date) => (moment(date).fromNow()),
                        timezone: process.env.LOCAL_TZ,
                      },
                    },
                    supplier: {
                      label: 'Supplier',
                      format: (field) => (field ? field.name : '--'),
                    },
                    code: {
                      label: 'Code',
                      format: (field, row) => (
                        row.supplier_program ? (`
                          ${row.supplier.programs.find(
                          (x) => x.name === row.supplier_program,
                        ).lot_prefix}
                        `) : '--'
                      ),
                    },
                    supplier_program: {
                      label: 'Program',
                    },
                    actions: {
                      label: props.t('Actions'),
                      actions: [
                        {
                          key: 'select',
                          icon: 'mdi mdi-check',
                          class: 'btn btn-sm btn-soft-dark',
                          alt: props.t('Select'),
                          click: (truck) => {
                            setFieldValue('truck', truck);
                          },
                        },
                      ],
                    },
                  },
                  pagination: {
                    sort: 'id',
                    direction: 'desc',
                    perPage: 10,
                  },
                }
                }
              />
            </div>
          )}

          {values.truck !== null && values.truck !== undefined && (
            <Row>
              <Col sm="6">
                <Label
                  for="truck_id"
                  className="pe-0 ps-0"
                >
                  {props.t('Truck')}
                </Label>
                <InputGroup>
                  <input readOnly type="text" className="form-control" value={`${values.truck.id}: ${values.truck.reference}`} />
                  <Button color="danger" className="btn-soft-danger" onClick={() => setFieldValue('truck', null)}>
                    <span className="mdi mdi-close-thick" />
                  </Button>
                </InputGroup>
              </Col>
              <Col sm="6">
                <Label
                  for="order_id"
                  className="pe-0 ps-0"
                >
                  {props.t('Order')}
                </Label>
                <Field as="select" name="order_id" className={`form-control ${(errors.order_id && touched.start ? 'is-invalid' : '')}`}>
                  <option value="">{props.t('Select an Order')}</option>
                  {values.truck.orders.map((order) => (
                    <option key={order.id} value={order.id}>{order.reference}</option>
                  ))}
                </Field>
                <ErrorMessage
                  name="order_id"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>
          )}
        </Form>
      )}
    </Formik>
  );

  return jsx;
}

AddressingForm.defaultProps = {
  entity: {

  },
  onSuccess: () => {},
};

AddressingForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(AddressingForm));
